import { TradeHistoryModel, type TradeHistoryRepository, type GetAllTradeHistoryDTO } from '@trading/core'
import type { TradeHistoryTrade } from '@trading/core'

const MOCK_TRADES_TOTAL = 60
const MOCK_PAGE_SIZE = 50

function buildMockTrade(index: number): TradeHistoryTrade {
  const openTime = new Date(Date.now() - index * 3_600_000)
  const closeTime = new Date(openTime.getTime() + 30 * 60_000)

  return {
    id: `mock-trade-${index}`,
    account_id: 'f9113aa0-f922-4772-b7c7-a7b3311d7ae1',
    symbol: 'BTCUSDT',
    side: index % 2 === 0 ? 'SHORT' : 'LONG',
    price: (67000 + index * 12.5).toFixed(18),
    quantity: '1.000000000000000000',
    fee: '0E-18',
    fee_currency: 'USDT',
    is_maker: false,
    realized_pnl: ((index % 3 === 0 ? -1 : 1) * index * 1.35).toFixed(18),
    trade_time: closeTime.toISOString(),
    open_time: openTime.toISOString(),
    close_time: closeTime.toISOString(),
    tp: '0',
    sl: '0',
    swap: '0.030000000000000000'
  }
}

const mockTrades: TradeHistoryTrade[] = Array.from({ length: MOCK_TRADES_TOTAL }, (_, i) =>
  buildMockTrade(i)
)

export class TradeHistoryApiMock implements TradeHistoryRepository {
  async getAll(dto: GetAllTradeHistoryDTO) {
    return new Promise<TradeHistoryModel>((res) => {
      setTimeout(() => {
        const cursorIndex = dto.after
          ? mockTrades.findIndex((trade) => String(trade.id) === dto.after)
          : -1

        if (dto.after && cursorIndex === -1) {
          res(new TradeHistoryModel([], { commission: '', pnl: '', swap: '' }, null))
          return
        }

        const start = cursorIndex + 1
        const end = start + MOCK_PAGE_SIZE
        const page = mockTrades.slice(start, end)
        const lastId = page.at(-1)?.id
        const nextCursor = end < mockTrades.length && lastId != null ? String(lastId) : null

        res(new TradeHistoryModel(page, { commission: '', pnl: '', swap: '' }, nextCursor))
      }, 1000)
    })
  }
}
